module.exports = __webpack_public_path__ + "static/media/pi-vipface-service.84f2a5b1.png";